var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChilddark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5833 8.59961H10.5958M18.0833 8.59961H18.0958M10.0022 13.5996C10.8667 15.0941 12.4826 16.0996 14.3333 16.0996C16.184 16.0996 17.7999 15.0941 18.6644 13.5996M14.3333 21.0996C18.9929 21.0996 22.9081 17.9127 24.0183 13.5996H24.3333C25.714 13.5996 26.8333 12.4804 26.8333 11.0996C26.8333 9.71886 25.714 8.59961 24.3333 8.59961H24.0183C22.9081 4.28655 18.9929 1.09961 14.3333 1.09961C9.67365 1.09961 5.7584 4.28655 4.6483 8.59961H4.33325C2.95254 8.59961 1.83325 9.71886 1.83325 11.0996C1.83325 12.4804 2.95254 13.5996 4.33325 13.5996H4.6483C5.7584 17.9127 9.67365 21.0996 14.3333 21.0996Z",
    stroke: "#838383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChilddark);
export default __webpack_public_path__ + "static/media/childdark.a1c81a4e22b1fcf0c89f1696e00652e0.svg";
export { ForwardRef as ReactComponent };